import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import IconSelect from 'static/images/categories/icon-site-selection.svg';
import IconProspects from 'static/images/categories/icon-prospects.svg';
import IconInfo from 'static/images/categories/icon-general-info.svg';
import IconPotential from 'static/images/categories/icon-invest-potential.svg';
import IconProjects from 'static/images/categories/icon-projects.svg';
import IconLock from 'static/images/icon-lock.svg';
import { getRoots } from 'selectors';
import { ProjectLayer } from 'types/omjs/project';
import { categoriesConfig, isCategoryAvailable } from './categories-config';
import './style.scss';

interface ICategorySelectorProps {
    onCategoryClick: (category: string) => void;
}

const icons = {
    select: IconSelect,
    potential: IconPotential,
    prospects: IconInfo,
    info: IconProspects,
    folder5: IconProjects,
    folder6: IconPotential
};

const CategorySelectorComponent: React.FC<ICategorySelectorProps> = ({ onCategoryClick }): JSX.Element => {
    const roots = useSelector(getRoots);

    const commonRoots = useMemo(
        () => roots.filter(r => isCategoryAvailable(r.get('code')) && !categoriesConfig[r.get('code')]?.private),
        [ roots ]
    );
    const privateRoots = useMemo(
        () => roots.filter(r => isCategoryAvailable(r.get('code')) && categoriesConfig[r.get('code')]?.private),
        [ roots ]
    );

    const renderCategoryIcon = (root: ProjectLayer, lock: boolean = false) => {
        const Icon = icons[root.get('code')];
        /* Если иконка не найдется, то упадет все приложение поэтому поставил проверку чтоб хотя бы не падало приложение */
        if (!Icon) {
            console.error(
                `Нету иконки для слоя ${root.get('code')}.`,
                `Зашитые слои с иконками: ${Object.keys(icons).join(', ')}`
            );
            return null;
        }

        return (
            <div
                key={root.get('id')}
                className="iris-category-selector__item"
                onClick={() => onCategoryClick(root.get('code'))}
            >
                <div className="iris-category-selector__item-icon">
                    <Icon />
                    {lock && (
                        <div className="iris-category-selector__item-lock-badge">
                            <IconLock />
                        </div>
                    )}
                </div>
                <div className="iris-category-selector__item-text">
                    {root.get('name')}
                </div>
            </div>
        );
    };

    return (
        <div className="iris-category-selector">
            {commonRoots.map(r => renderCategoryIcon(r))}
            {privateRoots.map(r => renderCategoryIcon(r, true))}
        </div>
    );
};

export const CategorySelector = CategorySelectorComponent;
